import 'core-js';
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';

import BlendAppRouter from './routers/BlendAppRouter';
import { BlendAppQuizzDataContextProvider } from './contexts/blendAppQuizzData-context';

require('babel-polyfill');

ReactDOM.render(
    <BlendAppQuizzDataContextProvider>
        <BlendAppRouter/>
    </BlendAppQuizzDataContextProvider>
    , 
    document.getElementById('BlendApp')
);
